import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
	title?: string;
	titleId?: string;
	desc?: string;
	descId?: string;
}
const LinkedIn = ({
	title,
	titleId,
	desc,
	descId,
	...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={25}
		fill="none"
		aria-labelledby={titleId}
		aria-describedby={descId}
		{...props}
	>
		{desc ? <desc id={descId}>{desc}</desc> : null}
		{title ? <title id={titleId}>{title}</title> : null}
		<path
			fill="#293455"
			d="M21.313 2H2.558A1.57 1.57 0 0 0 1 3.577v18.72c0 .87.698 1.578 1.558 1.578h18.755c.859 0 1.562-.708 1.562-1.577V3.578c0-.87-.703-1.578-1.563-1.578ZM7.61 20.75H4.37V10.31h3.247v10.44h-.005ZM5.991 8.885a1.88 1.88 0 0 1 0-3.76c1.034 0 1.88.845 1.88 1.88 0 1.04-.84 1.88-1.88 1.88ZM19.764 20.75h-3.242v-5.078c0-1.211-.025-2.769-1.685-2.769-1.69 0-1.948 1.319-1.948 2.681v5.166H9.647V10.31h3.11v1.426h.045c.434-.82 1.494-1.684 3.071-1.684 3.281 0 3.892 2.163 3.892 4.975v5.723Z"
		/>
	</svg>
);
export default LinkedIn;
